<template>
  <div class="flex flex-column gap-4">
    <div class="flex justify-content-between align-items-center">
      <h3 class="m-0">Note</h3>
    </div>
    <div class="flex flex-column gap-2">
      <a-textarea v-model="note" placeholder="Type the note" :rows="18" />
      <a-button class="w-fit ml-auto" type="primary" :loading="loading" @click="submit" icon="save"> Save </a-button>
    </div>
  </div>
</template>

<script>
import { Input, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: shiftActions, mapState: shiftState } = createNamespacedHelpers('shifts')

export default {
  components: {
    'a-textarea': Input.TextArea
  },
  data() {
    return {
      loading: false,

      note: undefined
    }
  },
  computed: {
    ...shiftState({
      shift: state => state.shift.shift
    })
  },
  watch: {
    shift: {
      handler(newVal) {
        this.note = newVal.note
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...shiftActions(['postShiftNote']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async submit() {
      this.loading = true
      try {
        const payload = {
          note: this.note,
          shift_id: this.shift.id
        }

        await this.postShiftNote(payload)

        this.showNotification('success', 'Success', 'Note was successfully changed')
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
